import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import H5 from './H5';
import getImageData from '../helpers/ImageHelper';
import NMImage from './shared/NMImage';

function GuideCard({ guide, alignment }) {
  const image = getImageData(guide?.attributes?.image);
  return (
    <div>
      <div className={`${alignment ? "w-full flex gap-4" : "w-[7.5rem] block"}`}>
      {image.src && (
        <NMImage
          src={image.src}
          alt={image.alt}
          width="120"
          height="120"
          className="rounded-full object-cover"
        />
      )}
      <div className="mt-1 text-center">
      <H5 text={guide?.attributes?.firstname || guide?.attributes?.lastname} className="mt-3 text-center " />
        <span>
          <FontAwesomeIcon
            icon={faCircleCheck}
            className=" mr-2 rounded-full bg-secondary-main text-sm text-white"
          />
        </span>
        <span className="text-center font-sans text-sm font-normal text-dark-800">Verified</span>
      </div>
      </div>
    </div>
  );
}

export default GuideCard;
